import React from 'react'

function DevFloatingTab({ accentColor = '#6b7280', variant = 'vertical', label = 'Desarrollo' }) {
  const commonAnchor = {
    href: 'https://dev.dkard.click/?utm_source=dkard&utm_medium=tab&utm_campaign=cta_float',
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'fixed right-0 top-1/2 -translate-y-1/2 z-50 select-none',
    'aria-label': 'Servicios de Desarrollo'
  }

  if (variant === 'vertical') {
    return (
      <a {...commonAnchor}>
        <div
          className="rounded-l-2xl shadow-lg px-2 py-4 text-white font-semibold tracking-wide hover:pl-4 transition-all duration-300 animate-pulse"
          style={{ backgroundColor: accentColor, writingMode: 'vertical-rl', textOrientation: 'upright' }}
        >
          {label}
        </div>
      </a>
    )
  }

  return (
    <a {...commonAnchor}>
      <div
        className="rounded-l-2xl shadow-lg px-4 py-3 text-white font-semibold tracking-wide hover:pr-6 transition-all duration-300 animate-pulse"
        style={{ backgroundColor: accentColor }}
      >
        {label}
      </div>
    </a>
  )
}

export default DevFloatingTab

